// Complete menu data for Ravintola Elit
export const menuData = {
  fi: {
    categories: [
      {
        id: 'pizzas-classic',
        name: 'Pizzat - Klassikot',
        items: [
          { name: 'Emiliana', price: '11,50 / 21,00€', desc: 'Jauheliha, mozzarella' },
          { name: 'Tropicana', price: '12,00 / 22,00€', desc: 'Kinkku, ananas' },
          { name: 'Salami pizza', price: '12,00 / 22,00€', desc: 'Salami, paprika' },
          { name: 'Pepperoni pizza', price: '12,00 / 22,00€', desc: 'Pepperoni, tonnikala' },
          { name: 'Americano', price: '12,50 / 23,00€', desc: 'Kinkku, ananas, aurajuusto' },
          { name: 'Opera special', price: '12,50 / 23,00€', desc: 'Kinkku, salami, tonnikala' },
          { name: 'Chicken Hawaii', price: '12,50 / 23,00€', desc: 'Kana, ananas, aurajuusto' },
          { name: 'Frutti di mare', price: '12,50 / 23,00€', desc: 'Tonnikala, katkarapu, simpukka' },
          { name: 'Margarita', price: '12,50 / 23,00€', desc: 'Tomaatti, mozzarella, basilika' },
          { name: 'Quatro', price: '13,50 / 25,00€', desc: 'Kinkku, herkkusieni, tonnikala, katkarapu' },
          { name: 'Dillinger', price: '13,50 / 25,00€', desc: 'Kinkku, salami, jauheliha, sipuli' },
          { name: 'Mexicana', price: '13,50 / 25,00€', desc: 'Pepperoni, ananas, jalapeno, tacokastike' },
          { name: 'Pekoni pizza', price: '13,50 / 25,00€', desc: 'Pekoni, salami, sipuli, kananmuna' },
          { name: 'Revontulet special', price: '13,50 / 25,00€', desc: 'Kebab, ananas, aurajuusto, savuporo' },
          { name: 'Buono', price: '13,50 / 25,00€', desc: 'Pepperoni, kebab, aurajuusto, paprika' },
          { name: 'Kasvis pizza', price: '13,50 / 25,00€', desc: 'Herkkusieni, oliivi, sipuli, paprika' },
          { name: 'Talon special', price: '13,50 / 25,00€', desc: 'Kebabliha, talon kastike, ranskalaiset ja salaatti' },
          { name: 'Finpower', price: '13,50 / 25,00€', desc: 'Kebab, salami, kinkku, jauheliha' },
          { name: 'Super salami', price: '13,50 / 25,00€', desc: 'Kebab, salami, kinkku, aurajuusto' },
          { name: 'Taju', price: '14,00 / 26,00€', desc: 'Salami, feta, jalapeno, ananas, smetana' },
          { name: 'Empire special', price: '14,00 / 26,00€', desc: 'Kinkku, salami, sipuli, katkarapu, valkosipuli' },
          { name: 'BBQ', price: '14,00 / 26,00€', desc: 'Kana, sipuli, pekoni, mozzarella, BBQ-kastike' },
          { name: 'Bombai', price: '14,00 / 26,00€', desc: 'Kana, ananas, tuore chili, curry-kastike, rucola' },
          { name: 'Parmigiana', price: '14,00 / 26,00€', desc: 'Grillattu munakoiso, basilika, parmesaani, pesto, mozzarella' }
        ]
      },
      {
        id: 'pizzas-premium',
        name: 'Premium Pizzat',
        items: [
          { name: 'Kebab pizza', price: '14,00 / 26,00€', desc: 'Kebab, sipuli, chili, tomaatti, aurajuusto' },
          { name: 'Vegetale', price: '14,00 / 26,00€', desc: 'Pinaatti, tuore chili, feta, kirsikkatomaatti, pesto' },
          { name: 'Di Capra', price: '15,00 / 27,00€', desc: 'Vuohenjuusto, paahdettu kesäkurpitsa, siemeniä, parmankinkku, kirsikkatomaatti, sipuli, pesto' },
          { name: 'Smetana', price: '15,00 / 27,00€', desc: 'Kebab, sipuli, chili, fetajuusto, tomaatti, smetana' },
          { name: 'Di Parma', price: '15,00 / 27,00€', desc: 'Parmankinkku, rucola, pesto, parmesaani, mozzarella, aurinkokuivattu tomaatti' }
        ]
      },
      {
        id: 'pizzas-own',
        name: 'Oma valinta',
        items: [
          { name: 'Yhdellä täytteellä', price: '11,00 / 20,00€', desc: 'Valitse yksi täyte' },
          { name: 'Kahdella täytteellä', price: '12,00 / 22,00€', desc: 'Valitse kaksi täytettä' },
          { name: 'Kolmella täytteellä', price: '13,00 / 24,00€', desc: 'Valitse kolme täytettä' },
          { name: 'Neljällä täytteellä', price: '14,00 / 25,00€', desc: 'Valitse neljä täytettä' }
        ]
      },
      {
        id: 'salads',
        name: 'Salaatit',
        items: [
          { name: 'Fetasalaatti', price: '15,90€', desc: 'Feta, sipuli, oliivi, paprika, tomaatti, kurkku, sitruunainen oliiviöljykastike' },
          { name: 'Tonnikala salaatti', price: '15,90€', desc: 'Tonnikala, punasipuli, maissi, tomaatti, kurkku, sitruunainen oliiviöljykastike' },
          { name: 'Caesar salaatti', price: '16,90€', desc: 'Grillattu kana, krutonki, caesar-kastike, kirsikkatomaatti, parmesaani' },
          { name: 'Vuohenjuustosalaatti', price: '17,90€', desc: 'Parmankinkku, grillattu vuohenjuusto, tummaleipä, tomaatti, kurkku, siemensekoitus, pesto, aurinkokuivattu tomaatti, parmesaani' }
        ]
      },
      {
        id: 'falafel',
        name: 'Falafelit',
        items: [
          { name: 'F1. Falafel leivällä', price: '12,00€', desc: '' },
          { name: 'F2. Falafel riisillä', price: '13,00€', desc: '' },
          { name: 'F3. Falafel perunoilla', price: '13,00€', desc: 'Lisuke: ranskalaiset, lohkoperunat, ristikkoperunat' },
          { name: 'F4. Falafel rulla', price: '13,00€', desc: '' }
        ]
      },
      {
        id: 'snacks',
        name: 'Snäks Ateriat',
        items: [
          { name: 'Pienet ranskalaiset', price: '5,00€', desc: '' },
          { name: 'Isot ranskalaiset', price: '7,00€', desc: '' },
          { name: 'Ristikkoperunat', price: '8,00€', desc: '' },
          { name: 'Sipulirenkaat', price: '8,00€', desc: '5 kpl sipulirenkaita + ranskalaiset' },
          { name: 'Mozzarellatikut', price: '9,00€', desc: '5 kpl mozzarellatikku + ranskalaiset' },
          { name: 'Kanakori', price: '13,00€', desc: '5 kpl nugetteja, 2 sipulirengasta, 2 mozzarellatikkua, ranskalaiset, curry dippi' }
        ]
      },
      {
        id: 'kids',
        name: 'Lapsille',
        items: [
          { name: 'Lasten pizza', price: '10,00€', desc: '2 täytteellä' },
          { name: 'Juustoburger', price: '10,00€', desc: '100 g pihvi, juusto, sipuli, tomaatti, suolakurkku, jääsalaatti' },
          { name: 'Nugetti ranskalaisilla', price: '10,00€', desc: '5 kpl nugetteja, curry dippi' },
          { name: 'Makkaraperunat', price: '10,00€', desc: '100 g makkara ja ranskalaiset' }
        ]
      },
      {
        id: 'burritos',
        name: 'Burritot',
        items: [
          { name: 'Fetaburrito', price: '17,90€', desc: 'Feta, sipuli, paprika, maissi, jalapeno, dippi, pehmeä vehnätortilla, nacho-salsa, cheddarjuustokastike' },
          { name: 'Kanaburrito', price: '18,50€', desc: 'Paistettu kana, sipuli, paprika, maissi, jalapeno, dippi, nacho-salsa, vehnätortilla, cheddarjuustokastike' },
          { name: 'Naudanliha burrito', price: '19,00€', desc: 'Paistettu naudanliha, sipuli, maissi, paprika, jalapeno, nacho-salsa, vehnätortilla, cheddarjuustokastike' }
        ]
      },
      {
        id: 'chicken',
        name: 'Kanaruoat',
        items: [
          { name: 'Currykana', price: '17,90€', desc: '200 g grillattu kanafile, paistettu ananas, currykastike, kasvikset' },
          { name: 'Kana gorgonzola', price: '18,90€', desc: 'Kanafile, gorgonzola-kermakastike, kasvikset' },
          { name: 'Pippurikana', price: '18,90€', desc: 'Kanafile, pippurikermakastike, kasvikset' },
          { name: 'Vuohenjuustokana', price: '18,90€', desc: 'Kanafile, vuohenjuusto, paholaisen hillo, kasvikset' }
        ]
      },
      {
        id: 'schnitzels',
        name: 'Leikkeet',
        items: [
          { name: 'Hawainleike', price: '16,90€', desc: 'Paneroitu porsaan ulkofile, ananas, kasvikset' },
          { name: 'Wienerleike', price: '16,90€', desc: 'Sitruuna, anjovis, kapris, kasvikset' },
          { name: 'Metsästäjänleike', price: '18,90€', desc: 'Herkkusieni, kermakastike, kasvikset' },
          { name: 'Aurajuustoleike', price: '18,90€', desc: 'Aurajuusto, kermakastike, kasvikset' },
          { name: 'Pippurileike', price: '18,90€', desc: 'Pippurikermakastike, kasvikset' },
          { name: 'Sveitsinleike', price: '19,90€', desc: 'Täytetty kinkulla ja juustolla, kasvikset' }
        ]
      },
      {
        id: 'steaks',
        name: 'Pihvit',
        items: [
          { name: 'Lehtipihvi', price: '19,00€', desc: 'Naudan ulkofile, maustevoi, kasvikset' },
          { name: 'Grillipihvi', price: '19,00€', desc: 'Naudan ulkofile, maustevoi, kasvikset' },
          { name: 'Sipulipihvi', price: '19,90€', desc: 'Paistettu sipuli, kasvikset' },
          { name: 'Pippuripihvi', price: '20,90€', desc: 'Pippurikastike, kasvikset' }
        ]
      },
      {
        id: 'burgers',
        name: 'Burgerit',
        subtitle: '(Norm / Ateria)',
        items: [
          { name: 'Juusto burger', price: '10,00 / 13,50€', desc: '100 g pihvi, juusto, salaatti, sipuli, tomaatti, suolakurkku' },
          { name: 'Tuplajuusto burger', price: '13,00 / 16,50€', desc: '190 g pihvi, juusto, salaatti' },
          { name: 'Chili burger', price: '13,50 / 17,00€', desc: 'Chili, juusto' },
          { name: 'Aura pekoni burger', price: '14,00 / 17,50€', desc: 'Pekoni, kananmuna' },
          { name: 'Kartanon burger', price: '14,00 / 17,50€', desc: '' },
          { name: 'King burger', price: '14,50 / 18,00€', desc: 'Vuohenjuusto, pekoni, BBQ' }
        ]
      },
      {
        id: 'kebabs',
        name: 'Kanakebabit',
        items: [
          { name: 'K1. Pitakebab', price: '12,00€', desc: '' },
          { name: 'K2. Riisillä', price: '13,00€', desc: '' },
          { name: 'K3. Ranskalaisilla', price: '13,00€', desc: '' },
          { name: 'K4. Lohkoperunoilla', price: '13,00€', desc: '' },
          { name: 'K5. Rulla', price: '13,00€', desc: '' },
          { name: 'K6. Salaatilla', price: '13,00€', desc: '' },
          { name: 'K7. Kermaperunoilla', price: '13,00€', desc: '' },
          { name: 'K8. Iskender', price: '14,00€', desc: '' },
          { name: 'K9. Valkosipuliperunoilla', price: '14,00€', desc: '' },
          { name: 'K10. Juustoperunoilla', price: '14,00€', desc: '' },
          { name: 'K11. Aurajuustoperunoilla', price: '14,00€', desc: '' }
        ]
      },
      {
        id: 'wings',
        name: 'Hot Wings',
        items: [
          { name: '10 kpl', price: '12,50€', desc: '' },
          { name: '14 kpl', price: '16,50€', desc: '' },
          { name: '18 kpl', price: '20,00€', desc: '' }
        ]
      },
      {
        id: 'drinks',
        name: 'Juomat',
        items: [
          { name: '0,33 limu', price: '3,00€', desc: '' },
          { name: '1 l maito', price: '3,00€', desc: '' },
          { name: 'Kahvi / tee', price: '2,50€', desc: '' },
          { name: '1,5 l limu', price: '6,00€', desc: '' }
        ]
      }
    ]
  }
};
